import React from 'react';
import { brandAssets } from '../../data/images';
type WordmarkProps = {
  size?: 'sm' | 'lg';
};

/**
 * Typographic fallback for the approved MarineForceLED wordmark.
 * When official crest / wordmark files are supplied in data/images.ts
 * they are rendered instead — the approved logo is never redrawn.
 */
export function Wordmark({
  size = 'sm'
}: WordmarkProps) {
  const text = size === 'lg' ? 'text-4xl md:text-5xl' : 'text-[22px]';
  return <span className="inline-flex items-center gap-3" data-id="element-60" data-mp="35j5not2gt7ee">
      {brandAssets.crest && <img src={brandAssets.crest} alt="MarineForceLED crest" className={size === 'lg' ? 'h-16 w-auto' : 'h-9 w-auto'} data-id="element-61" data-mp="3adiclimpnaxj" />}
      {brandAssets.wordmark ? <img src={brandAssets.wordmark} alt="MarineForceLED" className={size === 'lg' ? 'h-12 w-auto' : 'h-6 w-auto'} data-id="element-62" data-mp="30lck87sjqrht" /> : <span className={`font-display leading-none ${text}`} aria-label="MarineForceLED" data-id="element-63" data-mp="2mmwcqemv0wym">
          <span className="font-bold tracking-[0.08em] text-white" data-id="element-64" data-mp="2qmogme1b6exn">MARINEFORCE</span>
          <span className="ml-1.5 font-medium tracking-[0.2em] text-marine" data-id="element-65" data-mp="hs4rtkxj6a0k">LED</span>
        </span>}
    </span>;
}